import { useMutation } from "@apollo/client";

import { gql } from "../../../__generated__";

const MEDIA_CREATE = gql(`
mutation MediaCreate($input: GqlMediaCreateInput!) {
    mediaCreateUploadable(input: $input) {
        id
        name
        mimeType
        isUploaded
        uploadUrl
    }
}`);

export default function useMediaCreate() {
    const [mediaCreate, { data, loading, error }] = useMutation(MEDIA_CREATE);

    return {
        mediaCreate: (name: string, mimeType: string) =>
            mediaCreate({
                variables: { input: { name, mimeType } },
            }),
        loading,
        error,
        data: data?.mediaCreateUploadable,
    };
}
